<template>
  <div id="my-message"  ref="message">
    {{ message }}
  </div>
</template>

<script type="text/javascript">
//import 'HelloWorld' from './components/HelloWorld.vue'
export default {
  name: "my-message",
  data() {
    return {
        message: '',
        // 事件
      duration: 2500,
      // 计时器
      timer: null,
    }
  },
  components: {},
  methods: {

    // 打开的方法
    showMessage(message) {
      this.message = message;
      // 过渡
      this.$refs.message.style.display = "block";
      // 计时器
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.closeMessage();
      }, this.duration);
    },
    // 关闭的方法
    closeMessage() {
      if (this.timer) {
        this.timer = clearTimeout(this.timer);
      }
      // 过渡
      this.$refs.message.style.display = "none";
    }

  }
}
</script>

<style lang="scss" scoped>
#my-message{
  position: fixed;
  z-index: 9999;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: #2B2B2F;
  font-size: 18px;
  color: #fff;
  padding: 18px 36px;
  border-radius: 50px;
  max-width: 70%;
  line-height: 28px;
  display: none;
}
</style>
